export const GETALLCOUNTRIES = 'GETALLCOUNTRIES';
export const GETCOUNTRYDETAIL = 'GETCOUNTRYDETAIL';
export const GETCOUNTRYBYNAME = 'GETCOUNTRYBYNAME';
export const ADDACTIVITY = 'ADDACTIVITY';
export const GETACTIVITIES = 'GETACTIVITIES';
export const ORDER = 'ORDER';
export const FILTER = 'FILTER';
//export const FILTERBYDIF = 'FILTERBYDIF';
export const CURRENTPAGE = 'CURRENTPAGE';
export const RESETFILTERS = 'RESETFILTERS';
export const CLEANCOUNTRYDETAIL = 'CLEANCOUNTRYDETAIL';
export const CLEANCOUNTRYSEARCH = 'CLEANCOUNTRYSEARCH';